import type { EventTrackingValues } from '@carvana/ds-carousel';

type CarouselAnalyticsActions = 'clicked' | 'swiped' | 'scrolled';

type CarouselAnalytics = {
  event: EventTrackingValues;
  location?: 'modal' | 'section';
};

export const INTERACTION_TO_ACTION: Record<
  EventTrackingValues['interactionType'],
  CarouselAnalyticsActions
> = {
  button: 'clicked',
  swipe: 'swiped',
  scroll: 'scrolled'
} as const;

export default CarouselAnalytics;
